import React from 'react'
import PropTypes from 'prop-types'
import Divider from 'material-ui/Divider'

export default class JobModulesDivider extends React.Component {

  static propTypes = {
    showDivider: PropTypes.bool
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.divider}>
          <div style={{ marginBottom: 20 }} />
          { this.props.showDivider &&
            <Divider />
          }
          <div style={{ marginBottom: 20 }} />
        </div>
      </div>
    )
  }
  
}

const styles = {
  
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fafafa'
  },

  divider: {
    marginLeft: 80,
    marginRight: 80
  }

}


// WEBPACK FOOTER //
// ./src/schedule/common/modules/JobModulesDivider.js